const map = {
	"./2010/Sponsors/img/ISCB.jpg": 93622,
	"./2010/Sponsors/img/elixir.jpg": 88560,
	"./2010/Sponsors/img/enfin.jpg": 43725,
	"./2010/Sponsors/img/esf.jpg": 54843,
	"./2010/Sponsors/img/sbf.jpg": 32686,
	"./2011/Sponsors/img/ISCB.jpg": 49039,
	"./2012/People/img/Günter_Jäger.jpg": 20712,
	"./2012/Sponsors/img/BMC.jpg": 13221,
	"./2012/Sponsors/img/ISCB.jpg": 4600,
	"./2012/Sponsors/img/amira.jpg": 67191,
	"./2012/Sponsors/img/bitplane.jpg": 54746,
	"./2012/Sponsors/img/rsob_open_biology.jpg": 78406,
	"./2013/People/img/Andrew_Tang.jpg": 77578,
	"./2013/People/img/Bruno_Sobral.jpg": 55412,
	"./2013/Sponsors/img/ISCB.jpg": 85073,
	"./2013/Sponsors/img/PerkinElmer.jpg": 38186,
	"./2014/People/img/Andrew_Tang.jpg": 28715,
	"./2014/People/img/Bruno_Sobral.jpg": 53975,
	"./2014/People/img/Max_Maletta.jpg": 58830,
	"./2014/Sponsors/img/ISCB.jpg": 66354,
	"./2014/Sponsors/img/Uni_Melbourne.jpg": 66975,
	"./2015/Sponsors/img/ISCB.jpg": 28763,
	"./2016/Sponsors/img/ISCB.jpg": 38308,
	"./2017/People/img/Speakers.jpg": 26596,
	"./2018/People/img/Michael_Joss.jpg": 7296,
	"./2018/People/img/Speakers.jpg": 98091,
	"./2018/Sponsors/img/BioDigital.jpg": 28571,
	"./2018/Sponsors/img/ISCB.jpg": 32094,
	"./2018/img/Banner.jpg": 3243,
	"./2019/People/img/Speakers.jpg": 77866,
	"./2019/Sponsors/img/ISCB.jpg": 35447,
	"./2020/img/Hero/Background.jpg": 63631,
	"./2020/img/Hero/Large.jpg": 69426,
	"./2020/img/Hero/Medium.jpg": 56346,
	"./2021/Sponsors/img/ISCB.jpg": 25914,
	"./2021/Sponsors/img/embl.jpg": 1329,
	"./2021/img/Hero/Background.jpg": 87082,
	"./2021/img/Hero/Large.jpg": 71745,
	"./2021/img/Hero/Medium.jpg": 70999,
	"./2022/Masterclass/img/banner/low_res.jpg": 23663,
	"./2022/People/img/Speakers.jpg": 95484,
	"./2022/img/Hero/Background.jpg": 2245,
	"./2022/img/Hero/Large.jpg": 24936,
	"./2022/img/Hero/Medium.jpg": 5740,
	"./2023/People/img/large/Alex_Jordan.jpg": 57766,
	"./2023/People/img/large/Alex_Ritter.jpg": 23482,
	"./2023/People/img/large/Arzu_Çöltekin.jpg": 62540,
	"./2023/People/img/large/Barbora_Kozlíková.jpg": 1495,
	"./2023/People/img/large/Christian_Stolte.jpg": 66510,
	"./2023/People/img/large/Drew_Berry.jpg": 75159,
	"./2023/People/img/large/Emmanuel_G._Reynaud.jpg": 47238,
	"./2023/People/img/large/Erez_Lieberman_Aiden.jpg": 69015,
	"./2023/People/img/large/Erez_Lieberman_Aiden_1.jpg": 18499,
	"./2023/People/img/large/Erez_Lieberman_Aiden_2.jpg": 72436,
	"./2023/People/img/large/Erez_Lieberman_Aiden_3.jpg": 60593,
	"./2023/People/img/large/Ivan_Viola.jpg": 47913,
	"./2023/People/img/large/Joanna_Leng.jpg": 8545,
	"./2023/People/img/large/Juri_Rappsilber.jpg": 72552,
	"./2023/People/img/large/Kathi_Zarnack.jpg": 34221,
	"./2023/People/img/large/Lina_Kim.jpg": 95745,
	"./2023/People/img/large/Marc_A._Marti-Renom.jpg": 69536,
	"./2023/People/img/large/Martin_Dohrn.jpg": 80930,
	"./2023/People/img/large/Martin_Smith.jpg": 62918,
	"./2023/People/img/large/Martina_Summer-Kutmon.jpg": 84586,
	"./2023/People/img/large/Michael_Krone.jpg": 54048,
	"./2023/People/img/large/Nadia_Magnenat-Thalmann.jpg": 17292,
	"./2023/People/img/large/Richard_Neher.jpg": 78335,
	"./2023/People/img/large/Sabrina_de_A._Silveira.jpg": 73697,
	"./2023/People/img/large/Sarah_Anne_Harris.jpg": 74695,
	"./2023/People/img/large/Seán_O'Donoghue.jpg": 4068,
	"./2023/People/img/large/Sinem_Saka.jpg": 28900,
	"./2023/People/img/large/Stefan_Bruckner.jpg": 86461,
	"./2023/People/img/large/Unknown.jpg": 80513,
	"./2023/People/img/large/Uwe_Ohler.jpg": 20833,
	"./2023/People/img/large/Virginie_Uhlmann.jpg": 44284,
	"./2023/People/img/large/Yuko_Mimori-Kiyosue.jpg": 63899,
	"./2023/Posters/img/AR-exhibit.jpg": 79311,
	"./2023/Posters/img/schol-ar+button.jpg": 9016,
	"./2023/Sponsors/img/embl.jpg": 62627,
	"./2023/Sponsors/img/embo-primary-black.jpg": 52175,
	"./2023/Sponsors/img/small/embl.jpg": 32379,
	"./2023/Sponsors/img/small/embo-primary-black.jpg": 48407,
	"./2023/VR/img/banner.jpg": 3486,
	"./2023/img/Assets/Poster.jpg": 36750,
	"./2023/img/Assets/holdingslide.jpg": 79209,
	"./2023/img/Hero/BackgroundGradient.jpg": 46296,
	"./2023/img/Hero/BackgroundNoGradient.jpg": 59929,
	"./2023/img/Hero/Medium.jpg": 16689,
	"./2024/People/img/Dmitry_Finkelberg.jpg": 81417,
	"./2024/People/img/large/Ahna_Skop.jpg": 41182,
	"./2024/People/img/large/Alex_McDowell.jpg": 40526,
	"./2024/People/img/large/Alexander_Ritter.jpg": 23635,
	"./2024/People/img/large/Alison_Young.jpg": 99741,
	"./2024/People/img/large/Anders_Ynnerman.jpg": 98050,
	"./2024/People/img/large/Barbora_Kozlíková.jpg": 50674,
	"./2024/People/img/large/Charlie_Sheehan.jpg": 56461,
	"./2024/People/img/large/Christian_Stolte.jpg": 91809,
	"./2024/People/img/large/Corey_Stevens.jpg": 79813,
	"./2024/People/img/large/David_Goodsell.jpg": 80150,
	"./2024/People/img/large/David_Koes.jpg": 56927,
	"./2024/People/img/large/Fei_Zhang.jpg": 82318,
	"./2024/People/img/large/Fiona_Naughton.jpg": 19792,
	"./2024/People/img/large/Jane_Richardson.jpg": 6582,
	"./2024/People/img/large/Jessica_Hullman.jpg": 67094,
	"./2024/People/img/large/Karen_Miga.jpg": 42812,
	"./2024/People/img/large/Katy_Börner.jpg": 43543,
	"./2024/People/img/large/Lorenzo_Casalino.jpg": 83378,
	"./2024/People/img/large/Martin_Krzywinski.jpg": 83063,
	"./2024/People/img/large/Martin_Smith.jpg": 24673,
	"./2024/People/img/large/Matthew_Taliaferro.jpg": 20988,
	"./2024/People/img/large/Rachel_Meyer.jpg": 29294,
	"./2024/People/img/large/Regina_Wetzer.jpg": 96746,
	"./2024/People/img/large/Remo_Rohs.jpg": 36094,
	"./2024/People/img/large/Scott_Fraser.jpg": 84441,
	"./2024/People/img/large/Seán_O'Donoghue.jpg": 10905,
	"./2024/People/img/large/Steven_Haddock-1.jpg": 86268,
	"./2024/People/img/large/Steven_Haddock.jpg": 35070,
	"./2024/People/img/large/Unknown.jpg": 95940,
	"./2024/People/img/large/Valentina_Pedoia.jpg": 6105,
	"./2024/People/img/large/Wesley_Legant.jpg": 13227,
	"./2024/img/Hero/Background-new.jpg": 47138,
	"./2024/img/Hero/Large.jpg": 92622,
	"./2024/img/Hero/Medium.jpg": 42094,
	"./2024/img/Hero/los-angeles+credit.jpg": 37925,
	"./2024/img/Hero/los-angeles.jpg": 2389,
	"./2025/People/img/Robert_Finn.jpg": 41209,
	"./2025/People/img/Rommie_Amaro.jpg": 84799,
	"./2025/People/img/large/Andy_Lomas.jpg": 60800,
	"./2025/People/img/large/Barbora_Kozlíková.jpg": 67173,
	"./2025/People/img/large/Beata_Edyta_Mierzwa.jpg": 76002,
	"./2025/People/img/large/Blake_Sweeney.jpg": 33839,
	"./2025/People/img/large/Christian_Stolte.jpg": 67028,
	"./2025/People/img/large/Cibele_Sotero-Caio.jpg": 697,
	"./2025/People/img/large/Daniel_Haehn.jpg": 55725,
	"./2025/People/img/large/Drew_Berry.jpg": 81206,
	"./2025/People/img/large/Ferdos_Abid_Ali.jpg": 18452,
	"./2025/People/img/large/Francesca_Ciccarelli.jpg": 8383,
	"./2025/People/img/large/Gesine_Müller.jpg": 19285,
	"./2025/People/img/large/Jaime_Huerta-Cepas.jpg": 61438,
	"./2025/People/img/large/James_Procter.jpg": 81889,
	"./2025/People/img/large/Janina_Wellmann.jpg": 62125,
	"./2025/People/img/large/Jessica_Xin_Hjaltelin.jpg": 85631,
	"./2025/People/img/large/Jonathan_Wood.jpg": 69112,
	"./2025/People/img/large/Laura_Garrison.jpg": 68802,
	"./2025/People/img/large/Lina_Kim.jpg": 63583,
	"./2025/People/img/large/Marc_Streit.jpg": 99734,
	"./2025/People/img/large/Meghna_Swayambhu.jpg": 25701,
	"./2025/People/img/large/Panagiotis_Kastritis-old.jpg": 53141,
	"./2025/People/img/large/Panagiotis_Kastritis.jpg": 81217,
	"./2025/People/img/large/Paula_Murphy.jpg": 82878,
	"./2025/People/img/large/Samuel_Flores-old.jpg": 23988,
	"./2025/People/img/large/Samuel_Flores.jpg": 34124,
	"./2025/People/img/large/Sarah_Marzi.jpg": 11838,
	"./2025/People/img/large/Seán_O'Donoghue.jpg": 20894,
	"./2025/People/img/large/Sofie_Louise_Valk.jpg": 23754,
	"./2025/People/img/large/Tobias_Isenberg.jpg": 29305,
	"./2025/People/img/large/Wolfram_Pönisch.jpg": 43585,
	"./2025/People/img/large/Wolfram_Pönisch_old.jpg": 9431,
	"./2025/People/img/large/Yann_Ponty.jpg": 97612,
	"./2025/People/img/large/enhanced/Marc_Streit.jpg": 34793,
	"./2025/People/img/large/enhanced/Meghna_Swayambhu copy.jpg": 26577,
	"./2025/People/img/large/enhanced/Meghna_Swayambhu.jpg": 44864,
	"./2025/People/img/large/enhanced/Paula_Murphy.jpg": 48659,
	"./2025/People/img/large/enhanced/Rommie_E._Amaro.jpg": 97380,
	"./2025/People/img/large/enhanced/Tobias_Isenberg.jpg": 80986,
	"./2025/People/img/large/enhanced/leonora foto.jpg": 1040,
	"./2025/Sponsors/img/Magdalene.jpg": 29899,
	"./2025/Venue/img/auditorium.jpg": 18036,
	"./2025/Venue/img/formal-hall.jpg": 42962,
	"./2025/Venue/img/magdalene.jpg": 66303,
	"./2025/Venue/img/river.jpg": 62223,
	"./2025/img/Hero/Background-new.jpg": 60471,
	"./2025/img/Hero/Medium.jpg": 95211,
	"./2026/People/img/large/Anne_Jungblut.jpg": 52310,
	"./2026/People/img/large/Barbora_Kozlíková.jpg": 31960,
	"./2026/People/img/large/Brady_Johnston+Samuel_Pantze+Vera_Williams.jpg": 9341,
	"./2026/People/img/large/Brady_Johnston+Samuel_Pantze.jpg": 47213,
	"./2026/People/img/large/Brady_Johnston.jpg": 93416,
	"./2026/People/img/large/Chiara_Barbieri.jpg": 81589,
	"./2026/People/img/large/Christian_Stolte.jpg": 97735,
	"./2026/People/img/large/Daniel_Haehn.jpg": 27638,
	"./2026/People/img/large/Daniel_Huson.jpg": 92413,
	"./2026/People/img/large/Fernanda_Viegas.jpg": 69021,
	"./2026/People/img/large/Heba_Sailem.jpg": 332,
	"./2026/People/img/large/Henning_Hermjakob.jpg": 4349,
	"./2026/People/img/large/Ian_Holmes.jpg": 36131,
	"./2026/People/img/large/Ivan_Viola.jpg": 98152,
	"./2026/People/img/large/James_Procter.jpg": 42188,
	"./2026/People/img/large/Jan_Willem_Tulp.jpg": 80198,
	"./2026/People/img/large/Jason_Swedlow.jpg": 6145,
	"./2026/People/img/large/Jernej_Ule.jpg": 75981,
	"./2026/People/img/large/Jonathan_Wood.jpg": 621,
	"./2026/People/img/large/Kat_Holt.jpg": 47638,
	"./2026/People/img/large/Maik_Wolfram-Schauerte.jpg": 92546,
	"./2026/People/img/large/Maja_Divjak.jpg": 69849,
	"./2026/People/img/large/Maja_Divjak_2.jpg": 11902,
	"./2026/People/img/large/Marta_Szachniuk.jpg": 61558,
	"./2026/People/img/large/Martin_Dohrn.jpg": 97407,
	"./2026/People/img/large/Martin_Krzywinski+Christian_Stolte.jpg": 23307,
	"./2026/People/img/large/Martin_Krzywinski.jpg": 32925,
	"./2026/People/img/large/Martin_Wattenberg.jpg": 4019,
	"./2026/People/img/large/Martina_Summer-Kutmon.jpg": 34241,
	"./2026/People/img/large/Meghna_Swayambhu.jpg": 72710,
	"./2026/People/img/large/Michael_Krone.jpg": 46283,
	"./2026/People/img/large/Paola_Perin.jpg": 1607,
	"./2026/People/img/large/Robert_Finn.jpg": 77951,
	"./2026/People/img/large/Samuel_Pantze+Vera_Williams.jpg": 36540,
	"./2026/People/img/large/Samuel_Pantze.jpg": 77020,
	"./2026/People/img/large/Sarah_Marzi.jpg": 5307,
	"./2026/People/img/large/Sarawuth_Wantha.jpg": 38545,
	"./2026/People/img/large/Seán_O'Donoghue.jpg": 84243,
	"./2026/People/img/large/Syma_Khalid.jpg": 83312,
	"./2026/People/img/large/Tanja_Stadler.jpg": 36164,
	"./2026/People/img/large/Teresa_Zulueta-Coarasa.jpg": 30600,
	"./2026/People/img/large/Thomas_Hollt.jpg": 76758,
	"./2026/People/img/large/Timo_Lucas.jpg": 92074,
	"./2026/People/img/large/Unknown.jpg": 87514,
	"./2026/People/img/large/Vera_Williams.jpg": 92105,
	"./2026/Sponsors/img/EG.jpg": 42406,
	"./2026/Sponsors/img/Magdalene.jpg": 29929,
	"./2026/Venue/img/auditorium.jpg": 19301,
	"./2026/Venue/img/formal-hall.jpg": 55933,
	"./2026/Venue/img/magdalene.jpg": 87616,
	"./2026/Venue/img/river.jpg": 50076,
	"./2026/img/Hero/Background-new.jpg": 73400,
	"./2026/img/Hero/Medium.jpg": 85088
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47502;